import { TextField, Typography } from "@mui/material"
import styled from "@emotion/styled"

export const InputContainer = styled.div``

export const Title = styled(Typography)`
  color: #5d5e62;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25rem;
  margin-bottom: 0.5rem;
`

export const CustomInput = styled(TextField)`
  font-size: 1rem;
  line-height: 1.5rem;
  letter-spacing: 0.15px;
  width: 100%;
  .MuiInputLabel-root {
    padding: 0;
    opacity: 0.6;
    top: -2px;
    transition: all 0.2s ease;
    color: #888aa7;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.1px;
  }
  input {
    color: ${({ theme }) => theme.palette.text.content};
    padding: 12.5px 14px;
  }
  .MuiOutlinedInput-root {
    border-radius: 12px;
    border: 1px solid rgba(136, 138, 167, 0.25);
    background: #f9f9f9;
  }
  .MuiOutlinedInput-notchedOutline {
    border: 0;
  }
  .Mui-focused {
    fieldset {
      border-color: rgba(0, 0, 0, 0.23) !important;
    }
    &.Mui-error {
      fieldset {
        border-color: ${({ theme }) => theme.palette.text.error} !important;
      }
    }
  }

  .MuiInputLabel-shrink {
    opacity: 0;
  }
  legend {
    position: relative;
    > span {
      padding-right: 0.75rem;
    }
  }
`
